import { ReactNode } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { noop, isEmpty } from 'lodash';
import { useForm, ValidationMode } from 'react-hook-form';
import { AnyObject, Lazy, ObjectSchema } from 'yup';
import { FormContext } from './ConnectForm';

type FormHOCProps = {
    formDefaultValues?: Record<string, any>;
    mode?: keyof ValidationMode;
    yupValidations?:
        | ObjectSchema<any, AnyObject, any, ''>
        | Lazy<any, AnyObject, any>;
    context?: object;
    shouldFocusError?: boolean;
    shouldUnregister?: boolean;
    children?: ReactNode;
};

const FormHOC = ({
    formDefaultValues = undefined,
    mode = 'onChange',
    yupValidations,
    children,
    context = undefined,
    shouldFocusError,
    shouldUnregister,
}: FormHOCProps) => {
    const methods = useForm({
        defaultValues: formDefaultValues,
        mode: mode,
        resolver: isEmpty(yupValidations)
            ? undefined
            : yupResolver(yupValidations),
        context,
        shouldFocusError,
        shouldUnregister,
    });
    return (
        <FormContext {...methods}>
            <form onSubmit={noop}>{children}</form>
        </FormContext>
    );
};

export default FormHOC;
